// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"584":"2b4fcceabb7f3895","945":"2dc27ba8827f92c8"}[chunkId] + "";
};